import { UPDATE_USER, SET_SELECTED_TENANT } from "../constants/User";

const initUser = {
	name: null,
	role: null,
	grupo: null,
	tenants: [],
	selectedTenant: null,
	awaitingTenantSelection: false,
	avisosModulos: [],
};

const user = (state = initUser, action) => {
	switch (action.type) {
		case UPDATE_USER: {
			const next = { ...state };
			if (action.name !== undefined) {
				next.name = action.name;
			}
			if (action.role !== undefined) {
				next.role = action.role;
			}
			if (action.grupo !== undefined) {
				next.grupo = action.grupo;
			}
			if (action.tenants !== undefined) {
				next.tenants = action.tenants;
			}
			if (action.selectedTenant !== undefined) {
				next.selectedTenant = action.selectedTenant;
			}
			if (action.awaitingTenantSelection !== undefined) {
				next.awaitingTenantSelection = action.awaitingTenantSelection;
			}
			if (action.avisosModulos !== undefined) {
				next.avisosModulos = action.avisosModulos;
			}
			return next;
		}
		case SET_SELECTED_TENANT:
			return {
				...state,
				selectedTenant: action.tenantSchema || null,
			};
		default:
			return state;
	}
};

export default user;
